<!--TODO Explain Code with comment modules-->
<template>
  <div class="w-full shadow-inner p-4 px-10 pr-5 bg-background-primary relative">
    <div class="absolute flex sm:hidden cursor-pointer left-0">
      <div class="shadow-lg p-1 px-1 pr-1 rounded-r-lg flex justify-center items-center" @click="toggleMenu(true)">
        <feather-icon icon="ChevronRightIcon"
                      svgClasses="h-5 w-5"/>
        <!--        <feather-icon icon="ChevronLeftIcon"-->
        <!--                      svgClasses="h-5 w-5"/>-->
      </div>

    </div>
    <div class="w-full flex flex-row justify-end mr-16">

      <div class="self-center flex theme_change">
        <feather-icon class="" icon="BellIcon" svgClasses="h-5 w-5"/>
      </div>
      <div class="self-center ml-3 mr-0 sm:mr-6 cursor-pointer relative"
           @click="(showOptions)? toggleOptions(false):toggleOptions(true)">
        <img :src="image" alt="user" class="w-8 rounded-full">
      </div>
      <!--      options-->
      <div v-if="showOptions"
           class="absolute mt-16 rounded-lg shadow z-20  py-2 px-1 pb-5 flex items-start flex-col sm:w-40 bg-background-primary">
        <div class="theme_change order-3 options" @click.prevent="changeTheme">

          <feather-icon v-if="color === 'theme-light'" icon="MoonIcon"
                        svgClasses="h-5 w-5"/>
          <feather-icon v-else icon="SunIcon"
                        svgClasses="h-5 w-5"/>

          <p class=""><span v-if="color === 'theme-light'">Dark</span><span v-else>Light</span> Mode</p>
        </div>
        <div class="order-1 options" @click="goToProfile">
          <feather-icon icon="UserIcon" svgClasses="h-5 w-5"/>
          <p class=""> Profile</p>
        </div>
        <div class="order-5 options" @click="logout">
          <feather-icon icon="LogOutIcon" svgClasses="h-5 w-5"/>
          <p class=""> Logout</p>
        </div>
        <div class="order-2 options" @click="showBarCode">
          <img v-if="color === 'theme-light'" :src="require('../../assets/images/code.svg')" alt="user" class=" w-5">
          <img v-else :src="require('../../assets/images/code_white.svg')" alt="user" class=" w-5">
          <p class=""> Bar Code</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TopBar',
  data: () => ({
    image: require('../../assets/images/profile_pic.png')
  }),
  computed: {
    ...mapGetters({
      user: 'user/user_info',
      color: 'theme/color',
      showOptions: 'rwd/show_options'
    })
  },
  methods: {
    ...mapActions({
      changeTheme: 'theme/change_Theme',
      logout: 'auth/logout',
      toggleOptions: 'rwd/toggleOptions',
      toggleMenu: 'rwd/toggleMenu'
    }),
    goToProfile () {
      this.$router.push('/profile')
      this.toggleOptions(false)
    },
    showBarCode () {
      this.$router.push({
        name: 'Profile',
        params: { showBarCode: '1' }
      })
      this.toggleOptions(false)
    }
  }
}
</script>

<style scoped>
.options {
  @apply py-1 flex px-4 pb-2 cursor-pointer mt-1 w-full border-b border-background-secondary;
}

.options p {
  @apply pl-2 ;
}

.theme_change {
  @apply ;
}
</style>
